import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const savePhotoPermission = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.PHOTO_PERMISSION_SAVE, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('写真使用許可保存エラー:', error);
    throw error;
  }
};

const getPhotoPermission = async () => {
  try {
    return await customFetch(API_ENDPOINTS.PHOTO_PERMISSION_SAVE, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('写真使用許可取得エラー:', error);
    throw error;
  }
};

const updatePhotoPermission = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.PHOTO_PERMISSION_SAVE, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('写真使用許可更新エラー:', error);
    throw error;
  }
};

export const photoPermissionService = {
  savePhotoPermission,
  getPhotoPermission,
  updatePhotoPermission
};
